import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { Link } from 'src/components/Link';

export interface BreedCardProps {
  image: IGatsbyImageData;
  link: string;
  title: string;
  onClick?: () => void;
}

const BreedCard: React.FC<BreedCardProps> = function ({ title, link, image, onClick = () => {} }) {
  return (
    <div className="pds-relative pds-flex pds-flex-col pds-items-start pds-justify-center pds-border-none">
      <Link
        className="pds-text-surface-text pds-no-underline hover:pds-text-surface-text focus:pds-underline active:pds-underline"
        to={link}
        onClick={onClick}
        analytics={false}
      >
        <GatsbyImage image={image} alt="" className="pds-rounded-xl" />
        <span className="pds-font-bold hover:pds-text-focus hover:pds-underline">{title}</span>
      </Link>
    </div>
  );
};

export default BreedCard;
